<script setup>
import { createServiceSchema } from '~/schemas/Service'

useHead({
  title: 'اتصال CRM کسب‌وکار با مرکز تلفن ابری نواتل',
  meta: [
    {  
      name: 'description', 
      content: 'نواتل امکان اتصال مرکز تلفن ابری به سیستم CRM شما را فراهم کرده است تا ارتباط با مشتریان را در محیطی یکپارچه، هوشمند و حرفه‌ای مدیریت کنید.'
    },
    { 
      hid: 'keywords', 
      name: 'keywords', 
      content: 'اتصال به crm, اتصال مرکزتلفن ابری به crm, اتصال به crm ابری, اتصال به سی ار ام ابری, اتصال به سی ار ام '
    },
  ],
   link: [
    {
      rel: 'canonical',
      href: "https://navatel.ir/connecting-with-crm/"
    }
  ],
  script: [
    {
      type: 'application/ld+json',
      textContent: JSON.stringify(createServiceSchema({
        name: "اتصال به CRM",
        alternateName: "Connecting With CRM",
        type: "CRM Telephony Integration",
        description: "نواتل یک ابزار ارتباطی است که همه افراد شرکت را با مشتریان آن در ارتباطی پویا و هدفمند نگه‌می‌دارد، حتی اگر آنها از راه دور کار کنند. با امکان اتصال به سی آر ام نواتل در هر مکان و زمان مخاطب خود را با شناخت او شگفت زده کنید. مذاکره‌ای که با حس خوب شروع شود، احتمال موفقیت بسیار بالایی دارد و یک حس مثبت و سازنده در دو طرف ایجاد می‌کند.",
        url: "https://navatel.ir/connecting-with-crm/",
        img: "/img/features/CRM.webp"
      }))
    },
  ],
})

const topCardDetails = ref({
  title: "اتصال به CRM، ارتباطی پویا و کارآمد",
  desc: `نواتل یک ابزار ارتباطی است که همه افراد شرکت را با مشتریان آن در ارتباطی پویا و هدفمند نگه‌می‌دارد، حتی اگر آنها از راه دور کار کنند. با امکان اتصال به سی آر ام نواتل در هر مکان و زمان مخاطب خود را با شناخت او شگفت زده کنید. مذاکره‌ای که با حس خوب شروع شود، احتمال موفقیت بسیار بالایی دارد و یک حس مثبت و سازنده در دو طرف ایجاد می‌کند.`,
  firstButton: { text: "دمو و مشاوره رایگان", modalId: "main" },
  secondButton: { text: "ارتباط با کارشناسان", modalId: "main" },
  img: "/img/features/CRM.webp",
})
const thirdCardDetails = ref([
  {
    id: 1,
    title:
      "یکپارچه‌سازی اطلاعات مشتریان برای افزایش بهره‌وری تیم‌های کاری",
    desc: "مدیریت ارتباطات شما با اتصال نواتل به سی آر ام",
    listThird: [
      {
        id: 0,
        img: "/img/features/CRM-2.webp",
        title: "دسترسی به اطلاعات مشتریان در کمترین زمان",
        desc: "با اتصال نواتل به سی آر ام شما، مشتری نیاز ندارد با هر بار تماس خود را معرفی کند و حس خوب مشتری‌مداری از این طریق به افراد منتقل خواهد شد.",
      },
      {
        id: 1,
        reverse: true,
        img: "/img/features/CRM-3.webp",
        title: "افزایش حس رضایتمندی مشتری",
        desc: "با اتصال سی آر ام به نواتل تمام افراد برای شما آشنا خواهند بود. اینکه لازم نباشد مشتری با هر بار تماس خود و نیازهایش را تکرار کند، برای هر مشتری خوشایند است و سبب جلب رضایت او از برند شما خواهد شد.",
      },
      {
        id: 2,
        full: true,
        title: "راه‌اندازی سریع، در کمترین زمان",
        desc: "برای اتصال سی آر ام به نواتل لازم نیست هزینه زیادی بپردازید و مدت زمان طولانی انتظار بکشید. در کمتر از چند ساعت شما می‌توانید از این ویژگی و امکانات خوب آن استفاده کنید.",
      },
    ],
  },
])
const forthCardDetails = ref({
  title: `چه ویژگی‌هایی سبب علاقه‌مندی کسب‌وکارها به اتصال به CRM نواتل شده است؟`,
  items: [
    {
      id: 0,
      img: "06",
      title: "کاملا ابری و بدون نیاز به سخت‌افزار",
    },
    { id: 1, img: "79", title: "رضایت بیشتر مشتری" },
    {
      id: 2,
      img: "17",
      title: "راه‌اندازی سریع و بدون نیاز به دانش فنی",
    },
    {
      id: 3,
      img: "41",
      title: "دسترسی به گزارشات متنوع",
    },
  ],
})
const lastCardDetails = ref({
  title: `با ما در ارتباط باشید.`,
  desc: `در صورتی که برای خرید، نصب و راه‌اندازی به مشاوره دارید با کارشناسان ما در ارتباط باشید.`,
  communicationMethods: [
    {
      id: 0,
      img: "/img/features/method1.webp",
      title: "چت آنلاین",
      link: { text: "گفتگو با ما", href: "" },
    },
    {
      id: 1,
      img: "/img/features/method2.webp",
      title: "ایمیل",
      link: { text: "office@sgas.ir", href: "mailto:office@sgas.ir" },
    },
    {
      id: 2,
      img: "/img/features/method3.webp",
      title: "تماس با پشتیبانی",
      link: { text: "021-82800000", href: "tel:+982182800000" },
    },
  ],
})
</script>

<template>
  <div>
    <BaseTopCard :details="topCardDetails" isDarkBlue />
    <BaseThirdCard :items="thirdCardDetails" />
    <PricesCrm
      title="تعرفه اتصال مرکز تلفن نواتل به سی آر ام"
      class="mt-16"
    />
    <div class="mt-[70px]">
      <BaseForthCard :details="forthCardDetails" />
    </div>
    <BaseLastCard :details="lastCardDetails" />
  </div>
</template>
